import { Box } from 'roo-ui/components';
import { Container, H2, H3, RedLink, SectionContainer, SmallContent, TextP } from '../primitives';

const UseOfPointsInfo = () => (
  <>
    <H3 lineHeight="20px">Use of Qantas Points</H3>
    <TextP>
      If a Member has redeemed Qantas Points for all or part of a booking and is eligible for a refund in relation to that booking, the
      Member can elect whether they receive that refund (less any applicable fee) in cash, Points, or a combination of cash and Points.
      However, the number of Points or the cash amount refunded in such circumstances cannot exceed the number of Points originally used or
      the cash amount originally paid in respect of the booking.
    </TextP>
  </>
);

const UseOfVoucherInfo = () => (
  <>
    <H3 lineHeight="20px">Use of Voucher</H3>
    <TextP>
      If you used a voucher for part or full payment of this booking, the amount paid for by the voucher is non-refundable and no
      replacement voucher will be issued when cancelling a booking. Any hotel change or cancellation fees amount will be deducted from the
      amount paid by you, up to a maximum of the amount originally paid by you. Any hotel change or cancellation fees value cannot be paid
      using the voucher value.
    </TextP>
  </>
);

const Disclaimers = () => (
  <TextP>
    † Includes fees payable in local currency directly to the hotel. Prices in AUD are approximated and based on the exchange rate at time
    of booking.
  </TextP>
);

const CompanyInfo = () => <TextP>Qantas Group Accommodation, a wholly owned subsidiary of the Qantas Group. ABN 32 152 774 457</TextP>;

const PrintViewFooter = () => (
  <SectionContainer>
    <Container>
      <Box as="article">
        <SmallContent>
          <H2>Important Information</H2>
          <TextP>This is not a tax invoice. Please find your tax invoice attached to your confirmation email.</TextP>
          <UseOfPointsInfo />
          <UseOfVoucherInfo />
          <Disclaimers />
        </SmallContent>
      </Box>
      <Box as="aside">
        <SmallContent>
          <TextP>
            <RedLink label="View terms and conditions" url="https://www.qantas.com/hotels/terms-of-use" />
          </TextP>
          <CompanyInfo />
        </SmallContent>
      </Box>
    </Container>
  </SectionContainer>
);

export default PrintViewFooter;
